const OffRoad = ({ ...props }) => {
  return (
    <svg
      width="188"
      height="195"
      viewBox="0 0 188 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.02441 169.166L38.6029 188.704L74.1814 169.166L109.76 188.704L145.338 169.166L180.917 188.704"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M3.02441 6.34961L38.6029 25.8876L74.1814 6.34961L109.76 25.8876L145.338 6.34961L180.917 25.8876"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M3.02441 129.439H22.3931"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M85.9219 129.439H105.291"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M168.049 129.439H187.418"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M3.02441 64.7461H22.3931"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M85.9219 64.7461H105.291"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M168.049 64.7461H187.418"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M44.1172 96.8223H63.4859"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M126.956 96.8223H146.325"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default OffRoad
